import { combineReducers } from 'redux';

import * as actionTypes from '../aciton-mgr/actionTypes';
import reportDialog from './ReportDialog';
import reportSearchForm from './ReportSearchForm';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_SUCCESS:
      return action.byId;
    case actionTypes.CLOSE_ERROR_REPORT_SUCCESS:
      return {
        ...state,
        ...action.byId
      };
    case actionTypes.REOPEN_ERROR_REPORT_SUCCESS:
      return {
        ...state,
        ...action.byId
      };
    default:
      return state;
  }
}

const ids = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SEARCH_SUCCESS:
      return action.ids;
    default:
      return state;
  }
}

const isSaving = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_REPORT_REQUEST:
      return true;
    case actionTypes.SUBMIT_REPORT_SUCCESS:
    case actionTypes.SUBMIT_REPORT_FAILURE:
      return false;
    default:
      return state;
  }
}

const isClosing = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CLOSE_ERROR_REPORT_REQUEST:
      return true;
    case actionTypes.CLOSE_ERROR_REPORT_FAILURE:
    case actionTypes.CLOSE_ERROR_REPORT_SUCCESS:
      return false;
    default:
      return state;
  }
}

const isReopening = (state = false, action) => {
  switch (action.type) {
    case actionTypes.REOPEN_ERROR_REPORT_REQUEST:
      return true;
    case actionTypes.REOPEN_ERROR_REPORT_FAILURE:
    case actionTypes.REOPEN_ERROR_REPORT_SUCCESS:
      return false;
    default:
      return state;
  }
}

const selectedErrorReportId = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_ERROR_REPORT:
      return action.errorrReportId;
    default:
      return state;
  }
}

const filterId = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.FILTER_STATUS:
      return action.filterId;
    default:
      return state;
  }
}

export default combineReducers({
  byId,
  ids,
  reportDialog,
  reportSearchForm,
  isSaving,
  filterId,
  selectedErrorReportId,
  isClosing,
  isReopening
})

const getCurrentState = state => state.errorReports;

export const getErrorReports = state => {
  const { byId, ids } = getCurrentState(state);
  return ids.map(id => byId[id]);
}

export const getIsSaving = state => getCurrentState(state).isSaving;

export const getSelectedErrorReport = state => {
  const { selectedErrorReportId, byId } = getCurrentState(state);
  return byId[selectedErrorReportId] || null;
}

export const getIsClosing = state => getCurrentState(state).isClosing;
export const getIsReopening = state => getCurrentState(state).isReopening;

export const getFilterStatusId = state => getCurrentState(state).filterId;
